import { useEffect, useRef, useState } from 'react';

/**
 * Replaces the system cursor with a blue dot on pointer devices (mouse).
 * Touch / coarse pointer devices are unchanged.
 */
function CustomCursor() {
  const dotRef = useRef<HTMLDivElement>(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    setEnabled(true);
  }, []);

  useEffect(() => {
    if (!enabled) return;

    const root = document.documentElement;
    root.setAttribute('data-custom-cursor', 'true');

    const onMove = (e: MouseEvent) => {
      const el = dotRef.current;
      if (el) {
        // Keep the blue dot slightly behind the pointer tip.
        el.style.transform = `translate3d(${e.clientX - 10}px, ${e.clientY - 10}px, 0) translate(-50%, -50%)`;
      }
    };

    window.addEventListener('mousemove', onMove, { passive: true });

    return () => {
      root.removeAttribute('data-custom-cursor');
      window.removeEventListener('mousemove', onMove);
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div
      ref={dotRef}
      className="custom-cursor-dot pointer-events-none fixed left-0 top-0 z-99998 h-4 w-4 rounded-full border border-[#3e0cf2] bg-transparent shadow-[0_0_12px_rgba(33,23,233,0.95)] will-change-transform"
      style={{ transform: 'translate3d(-100px, -100px, 0) translate(-50%, -50%)' }}
      aria-hidden
    />
  );
}

export default CustomCursor;
